import {
  Link, MemoryRouter, Router, Route, Redirect, Switch, withRouter,
} from '@ipc/routing';
import { useLocation } from 'react-router-dom';

export {
  Link, MemoryRouter, Router, Route, Redirect, Switch, withRouter, useLocation,
};
